import './style.css';
import { jsxs as f, jsx as l } from "react/jsx-runtime";
import { c as p } from "../../__shared__/index.js";
import c from "../../controls/PriceLabel/PriceLabel.js";
const w = "_wrapper_yxv1v_1", _ = "_wrapperColumn_yxv1v_9", N = "_priceFirst_yxv1v_15", a = {
  wrapper: w,
  wrapperColumn: _,
  priceFirst: N
};
function b({
  price: n = void 0,
  strikethroughPrice: r = void 0,
  layoutMode: m = "row",
  layoutOrder: v = "price-last",
  locale: o,
  currencyCode: s,
  priceFormatter: e
}) {
  const d = n == null || Number.isNaN(n) || n === 1 / 0, u = r == null || Number.isNaN(r) || r === 1 / 0, i = d ? "" : e(n, o, s), t = u ? "" : e(r, o, s);
  return !i && !t ? null : /* @__PURE__ */ f(
    "div",
    {
      className: p(
        a.wrapper,
        m === "column" ? a.wrapperColumn : void 0
      ),
      children: [
        t && /* @__PURE__ */ l(
          c,
          {
            formattedPrice: t,
            variant: "strikethrough",
            class: p(
              v === "price-first" ? a.priceFirst : null
            )
          }
        ),
        i && /* @__PURE__ */ l(
          c,
          {
            formattedPrice: i,
            variant: r ? "reduced" : "default"
          }
        )
      ]
    }
  );
}
export {
  b as default
};
//# sourceMappingURL=PriceContainer.js.map
